module.exports = __webpack_public_path__ + "img/dash-VARILUX-S-SERIES_full_white.709d5560.png";